import { useDispatch, useSelector } from "react-redux";
import { IMeetingReducerState } from "../../interfaces/store/IMeetingReducerState";
import { useEffect, useState } from "react";

import CustomTable from "../common/ui/CustomDataGridTableFePag";
import { useNavigate } from "react-router-dom"
// NOTE:: keep Commented below code as edit delete will go in phase 2 once fully functionality done that will add
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { GridRenderCellParams } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import { actionTypes } from "../../store/actionTypes/actionTypes";
import { ADMIN } from "../../constants/admin";
import { Box, IconButton } from "@mui/material"; 
import LoaderWithText from "../common/ui/LoaderWithText";
import { UserPermission } from "../common/UserPermission";
import { RestfulUrls } from "../../constants/restfulUrls";
import { postDataFromApi } from "../../services/api/apiService";
import { COMMON } from "../../constants/common";
import { IApiResponse } from "interfaces/common/IApiResponse";
import { isAfter, isBefore, parseISO } from "date-fns";


const MeetingsTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [disableDeleteSubmitBtn, setDisableDeleteSubmitBtn] = useState(false);
  const [isResetAgendaModalOpen, setIsResetAgendaModalOpen] = useState<boolean>(false);
  const [disableResetSubmitBtn, setDisableResetSubmitBtn] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<{ id: string } | null>(
    null
  );
  const [selectedResetRowData, setSelectedResetRowData] = useState<{ id: string } | null>(
    null
  );
  const meetingTableData = useSelector(
    (state: { meeting: IMeetingReducerState }) => state.meeting.meetingTableData
  );

  const [rowData, setRowData] = useState<any>([]);
 
  // NOTE:: keep Commented below code as edit delete will go in phase 2 once fully functionality done that will add
   const onEditIconClick = (selectedRow: any) => {
    dispatch({
      type: actionTypes.UPDATE_MEETING_OPEN,
      payload: true,
    });
    dispatch({
      type: actionTypes.UPDATE_SELECTED_ROW_TABLE_DATA,
      payload: selectedRow,
    });
    dispatch({
      type: actionTypes.UPDATE_MEETING_FORM_TYPE,
      payload: ADMIN.MEETING_FORM_TYPE.EDIT,
    });
  }; 

  const getMeetingDetails = async () => {
      const url = `${RestfulUrls.BASE_URL}${RestfulUrls.MEETING_LIST}`;
      const payloadData = {};
      dispatch({
        type: actionTypes.UPDATE_MEETING_FORM_LOADING,
        payload: true,
      });
      await postDataFromApi<any>(
        url,
        payloadData,
        (response: IApiResponse<any>) => {
          dispatch({
            type: actionTypes.UPDATE_MEETING_TABLE_DATA,
            payload: response.data,
          });
          dispatch({
            type: actionTypes.UPDATE_MEETING_FORM_LOADING,
            payload: false,
          });
        },
        { isAuthRequired: true },
        navigate
      );
      dispatch({
        type: actionTypes.UPDATE_MEETING_FORM_LOADING,
        payload: false,
      });
    };
    
  const dummyModalCloseTw = () => {};
  
  const handleDeleteMeeting = async () => {
    setDisableDeleteSubmitBtn(true);
    setLoading(true);
  
    try {
      const url = `${RestfulUrls.BASE_URL}${RestfulUrls.DELETE_MEETING}`;
      const payload = {
        id: String(selectedRowData?.id), 
      };
  
      await postDataFromApi<any>(
        url,
        payload,
        () => {
          dispatch({
            type: COMMON.SHOW_SNACKBAR,
            payload: {
              message: "Meeting deleted successfully.",
              severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
            },
          });
          getMeetingDetails();
          setIsDeleteModalOpen(false);
          setDisableDeleteSubmitBtn(false);
        },
        { isAuthRequired: true },
        navigate
      );
    } catch (error) {
      console.error("Delete meeting failed", error);
    } finally {
      setLoading(false);
      setDisableDeleteSubmitBtn(false);
    }
  };  
  
  const onSelectedDeleteIconClick = (selectedRow: any) => {
    setIsDeleteModalOpen(true);
    setSelectedRowData(selectedRow);
  };
  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedRowData(null);
  };

  const onSelectedResetIconClick = (selectedRow: any) => {
    setIsResetAgendaModalOpen(true);
    setSelectedResetRowData(selectedRow);
  };

  const handleCloseResetModal = () => {
    setIsResetAgendaModalOpen(false);
    setSelectedResetRowData(null);
  };

  const handleResetAgendaAndSummaries = async () => {
    if (!selectedResetRowData) return;
    
    setDisableResetSubmitBtn(true);
    setLoading(true);
  
    try {
      const url = `${RestfulUrls.BASE_URL}${RestfulUrls.RESET_AGENDA_SUMMARIES}`;
      const payload = {
        id: String(selectedResetRowData.id), 
      };
  
      await postDataFromApi<any>(
        url,
        payload,
        () => {
          dispatch({
            type: COMMON.SHOW_SNACKBAR,
            payload: {
              message: "Agenda and summaries deleted for the meeting",
              severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
            },
          });
          getMeetingDetails();
          setIsResetAgendaModalOpen(false);
          setDisableResetSubmitBtn(false);
        },
        { isAuthRequired: true },
        navigate
      );
    } catch (error) {
      console.error("Reset agenda and summaries failed", error);
      dispatch({
        type: COMMON.SHOW_SNACKBAR,
        payload: {
          message: "Failed to reset agenda and summaries",
          severity: COMMON.SNACKBAR_SEVERITY.ERROR,
        },
      });
    } finally {
      setLoading(false);
      setDisableResetSubmitBtn(false);
    }
  };

  const toLocalDateTime = (dateStr: string, timeStr: string): Date => {    
    const utcDate = new Date(`${dateStr}T${timeStr}Z`);
    return utcDate;
  };
  const formatLocalDate = (dateStr: string, timeStr: string): string => {
    const date = toLocalDateTime(dateStr, timeStr);
    if (isNaN(date.getTime())) return 'Invalid Date';
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
  
    return `${day}-${month}-${year}`;
  };
    
  useEffect(() => {
    if (meetingTableData) {
      const rowFinalData: any[] = [];
      meetingTableData?.data?.forEach((element: any) => {
        const meeting: Meeting = {
          Id: element?.Id,
          Title: element.Title,
          Passcode: element?.Passcode,
          MeetingUrl: element?.MeetingUrl,
          Agenda: element?.Agenda,
          Category: element?.Category,
          FromDate: element?.FromDate,
          ToDate: element?.ToDate,
          StartTime: element?.StartTime,
          EndTime: element?.EndTime,
          MeetingId: element?.MeetingId,
          Tag: element?.Tag,
          Fullday: element?.Fullday,
        };
  
        const data = {
          id: meeting.Id,
          title: meeting.Title,
          passcode: meeting.Passcode,
          meeting_url: meeting.MeetingUrl,
          agenda: meeting.Agenda,
          category: meeting.Category,
          from_date: meeting.FromDate,
          to_date: meeting.ToDate,
          start_time: meeting.StartTime,
          end_time: meeting.EndTime,
          meeting_id: meeting.MeetingId,
          tag: meeting.Tag,
          fullday: meeting.Fullday,
          actions: true         
        };
  
        rowFinalData.push(data);
      });
      setRowData(rowFinalData);
    } else {
      setRowData([]);
    }
  }, [meetingTableData]);
  
  type Meeting = {
    Id: number;
    Title: string;
    Passcode: string;
    MeetingUrl: string;
    Agenda: string;
    Category: string;
    FromDate: string;
    ToDate: string;
    StartTime: string;
    EndTime: string;
    MeetingId: string;
    Tag: string;
    Fullday: boolean;
  };
  
  type MeetingStatus = "Past" | "Active" | "Future";

  
   const getMeetingStatus = (meeting: Meeting): MeetingStatus => {
     const now = new Date();
 
     // Parse the meeting dates and times
     const startDate = parseISO(meeting.FromDate);
     const endDate = parseISO(meeting.ToDate);
 
     // Parse the new 24-hour time format (HH:mm)
     const [startHour, startMinute] = meeting.StartTime.split(":") || [];
     const [endHour, endMinute] = meeting.EndTime.split(":") || [];
 
     // Create full datetime objects
     const startDateTime = new Date(startDate);
     startDateTime.setHours(parseInt(startHour), parseInt(startMinute), 0);
 
     const endDateTime = new Date(endDate);
     endDateTime.setHours(parseInt(endHour), parseInt(endMinute), 0);
 
     // Determine status
     if (isAfter(startDateTime, now)) {
       return "Future";
     } else if (isBefore(endDateTime, now)) {
       return "Past";
     } else {
       return "Active";
     }
   };

  //  const isDeletable = (meeting: Meeting): boolean => {
  //   return getMeetingStatus(meeting) !== "Active";
  // };

  const tableHeader = [
    {
      field: "id",
      headerName: <div className='fw-700'>id</div>,
      width: 10,
    },
    {
      field: "title",
      headerName: <div className='fw-700'>Title</div>,
      width: 250,
    },
    {
      field: "agenda",
      headerName: <div className='fw-700'>Description</div>,
      width: 200,
    },
    {
      field: "meeting_url",
      headerName: <div className='fw-700'>Meeting Url</div>,
      width: 350,
    },
    {
      field: "category",
      headerName: <div className='fw-700'>Category</div>,
      width: 100,
    },
    {
      field: "from_date",
      headerName: <div className='fw-700'>From Date</div>,
      width: 120, 
      renderCell: (params: GridRenderCellParams) => (
        <span>{formatLocalDate(params.row.from_date, params.row.start_time)}</span>
      ),   
    },
   
    {
      field: "to_date",
      headerName: <div className='fw-700'>To Date</div>,
      width: 120  ,
      renderCell: (params: GridRenderCellParams) => (
        <span>{formatLocalDate(params.row.to_date, params.row.end_time)}</span>
      )   
    },   

  {
  field: "actions",
  headerName: <div className='fw-700'>Actions</div>,
  width: 150,
  renderCell: (params: GridRenderCellParams) => {
    const meeting = {
      Id: params.row.id,
      Title: params.row.title,
      Passcode: params.row.passcode,
      MeetingUrl: params.row.meeting_url,
      Agenda: params.row.agenda,
      Category: params.row.category,
      FromDate: params.row.from_date,
      ToDate: params.row.to_date,
      StartTime: params.row.start_time,
      EndTime: params.row.end_time,
      MeetingId: params.row.meeting_id,
      Tag: params.row.tag,
      Fullday: params.row.fullday,
    };

    // Determine if the meeting is deletable based on the status
    const isDeletable = getMeetingStatus(meeting) !== "Active";

    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>       
        <Tooltip title="Edit Meeting">
          <IconButton
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              onEditIconClick(params.row);
            }}
          >
            {params.value ? <EditOutlinedIcon className="de-icon" /> : null}
          </IconButton>
        </Tooltip>
    
        <Tooltip title="Reset Intervention and Agenda Item Summaries.">
          <IconButton
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              onSelectedResetIconClick(params.row);
            }}
          >
            <RestartAltIcon className="de-icon" />
          </IconButton>
        </Tooltip>
    
        <Tooltip title={isDeletable ? "Delete Meeting" : "Active meetings cannot be deleted."}>
          <span>
            <IconButton
              size="small"
              disabled={!isDeletable} // Disable if not deletable (i.e., active meeting)
              onClick={() => onSelectedDeleteIconClick(params.row)}
            >
              <DeleteOutlineOutlinedIcon className="de-icon" />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    );
  }
}

    
  ];

  useEffect(() => {
    if (meetingTableData) {
      const rowFinalData: any = [];
      meetingTableData?.data?.forEach((element: any) => {
        const data = {
          id: element?.Id,
          title: element.Title,
          passcode: element?.Passcode,
          meeting_url: element?.MeetingUrl,
          agenda: element?.Agenda,
          category: element?.Category,
          from_date: element?.FromDate,
          to_date: element?.ToDate,
          start_time: element?.StartTime,
          end_time: element?.EndTime,
          meeting_id: element?.MeetingId,
          tag: element?.Tag,
          fullday: element?.Fullday,
          actions: true,
        };

        rowFinalData.push(data);
      });
      setRowData(rowFinalData);
    } else {
      setRowData([]);
    }
  }, [meetingTableData]);

  return (
    <>
    <CustomTable
      columns={tableHeader}
      rows={rowData}
      hideFooter={false}
      disableColumnFilter={false}
      checkboxSelection={false}
      disableColumnSelector={true}
      disableDensitySelector={true}
      className='extraction_datatable'
      showToolbar={false}
    />
     <LoaderWithText isOpen={loading} onClose={dummyModalCloseTw} />
    <UserPermission
    isModalOpen={isDeleteModalOpen}
    titleOne={"Are you sure"}
    title={"you want to delete selected item?"}
    disableSubmitBtn={disableDeleteSubmitBtn}
    onConfirmedButtonClick={handleDeleteMeeting}
    onCancelButtonClick={handleCloseDeleteModal}
    onCloseModal={handleCloseDeleteModal}
  />
    <UserPermission
    isModalOpen={isResetAgendaModalOpen}
    titleOne={"Are you sure you want to reset intervention and agenda item summaries?"}
    title={""}
    disableSubmitBtn={disableResetSubmitBtn}
    onConfirmedButtonClick={handleResetAgendaAndSummaries}
    onCancelButtonClick={handleCloseResetModal}
    onCloseModal={handleCloseResetModal}
  />
  </>
  )   
      
};

 export default MeetingsTable;


